import { apiClient } from './apiClient';

type CsrfTokenResponse = {
  creds?: {
    csrfToken?: string;
  };
};

/**
 * Fetch a CSRF token from the backend (required for mutating requests).
 * The /v2/user/info endpoint returns creds even for anonymous sessions.
 */
export async function fetchCsrfToken(): Promise<string | null> {
  try {
    const response = await apiClient<CsrfTokenResponse>({ path: '/v2/user/info' });
    return response.creds?.csrfToken || null;
  } catch {
    return null;
  }
}
